
// import { Constants } from '../app.constant';

export const PAGES_AD_MENU = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'general.menu.dashboard',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'qmsdashboard',
        data: {
          menu: {
            title: 'QMS Dashboard',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      // {
      //   path: 'demographic-dashboard',
      //   data: {
      //     menu: {
      //       title: 'general.menu.demographicDashboard',
      //       icon: 'zmdi zmdi-view-dashboard',
      //       selected: false,
      //       expanded: false,
      //       order: 0
      //     }
      //   }
      // },

      /*{
        path: 'notifications',
        data: {
        menu: {
          title: 'Notifications',
          icon: 'zmdi zmdi-view-dashboard',
          selected: false,
          expanded: false,
          order: 0
        }
        }
      },*/      
      {
        path: 'cms',
        data: {
          menu: {
            title: 'general.menu.pending-approval',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: 'campaign-approval-list',
            data: {
              menu: {
                title: 'Campaign',
              }
            }
          }
        ]
      },
      {
        path: 'admin',
        data: {
          menu: {
            title: 'general.menu.user',
            icon: 'zmdi zmdi-account-circle',
            selected: false,
            expanded: false,
            order: 500,
          }
        },
        children: [
           {
             path: 'pending-approval-list-customer',
             data: {
               menu: {
                 title: 'general.menu.pendingApprovalCustomerList',
               }
             }
           },
          {
            path: 'list-customer',
            data: {
              menu: {
                title: 'general.menu.customer',
              }
            }
          },
          {
            path: 'list-roles',
            data: {
              menu: {
                title: 'general.menu.role',
                // hidden: Constants.isMenuEnable('list-roles')
              }
            }
          },
          {
            path: 'list-user',
            data: {
              menu: {
                title: 'User Management',
              }
            }
          },
          {
            path: 'premises',
            data: {
              menu: {
                title: 'general.menu.licenceHistoryMenu',
              }
            }
          },
          {
            path: 'list-onpremise',
            data: {
              menu: {
                title: 'general.menu.onPremise',
              }
            }
          }
        ]
      },
      {
        path: 'reports',
          data: {
            menu: {
              title: 'general.menu.report',
              icon: 'zmdi zmdi-chart',
              selected: false,
              expanded: false,
              order: 500,
            }
          },
          children: [
           {
            path: 'bandwidth-all-customer',
            data:{
              menu:{
               title:'Bandwidth Report'
              }
            }
          },
          {
            path: 'pdn-report',
            data:{
              menu:{
               title:'SDN Report'
              }
            }
          }
          // ,
          // {
          //   path: 'customer-tiers-switch-report',
          //   data:{
          //     menu:{
          //      title:'Customers Tier Report'
          //     }
          //   }
          // }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.ad.menu.ts